import React from 'react';
import { Box, InputAdornment, Typography } from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';
import styles from './styles.module.css';
import cn from 'classnames';
import { InputHelperText } from '../FormInputs';
import PropTypes from 'prop-types';
import { maskUserPhoneNumber } from 'utils/utilities';

const InputPhone = ({
    label,
    labelClass,
    placeholder,
    name,
    error,
    helperText,
    form,
    EndAdornmentIcon,
    enableMask = false,
    ...otherProps
}) => {
    const { onChange, onClickEndIcon, ...rest } = otherProps;

    const handlePhoneNumberChange = (phone) => {
        if (!phone || phone.trim() === '') {
            form.setFieldValue(name, '');
            return;
        }

        form.setFieldValue(name, phone);
    };

    return (
        <Box className={styles.inputWrapper}>
            <Typography className={cn(styles.label, labelClass)}>{label}</Typography>
            <PhoneInput
                value={form?.values?.[name]}
                placeholder={placeholder}
                country="us"
                inputProps={{
                    name,
                    variant: rest?.variant,
                    ...(enableMask && { value: maskUserPhoneNumber(form?.values?.phoneNumber) }),
                }}
                onChange={handlePhoneNumberChange}
                isValid={!error}
                containerClass={error && styles.inputError}
                {...rest}
            />
            {EndAdornmentIcon && (
                <InputAdornment className={styles.adornmentIcon} onClick={onClickEndIcon}>
                    <EndAdornmentIcon />
                </InputAdornment>
            )}
            {error && <InputHelperText helperText={helperText} />}
        </Box>
    );
};

InputPhone.propTypes = {
    label: PropTypes.string,
    labelClass: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    form: PropTypes.object,
    EndAdornmentIcon: PropTypes.node,
    enableMask: PropTypes.bool,
};

export default InputPhone;
